import { render, staticRenderFns } from "./add_to_home_screen_banner.vue?vue&type=template&id=10d34ebe&"
import script from "./add_to_home_screen_banner.vue?vue&type=script&lang=js&"
export * from "./add_to_home_screen_banner.vue?vue&type=script&lang=js&"
import style0 from "./add_to_home_screen_banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports